<template>
    <div class="pb-5 flex flex-col">
        <div class="flex-1 lg:mr-5">
            <p>The flash got detected successfully! We are now ready to read/write/erase!</p>
            <p class="mt-5">
                <div class="flex flex-wrap gap-4">

                    <div class="flex mt-2">
                        <!-- <VButton @click="read" variant="green" >READ CONTENTS</VButton> -->
                    </div>  
                    <div class="flex mt-2">
                        <VButton @click="read" variant="green" group="left" >READ</VButton>
                        <VButton @click="confirmErase" variant="dark" group="middle">ERASE</VButton>
                        <VButton @click="confirmWrite" variant="dark" group="right">WRITE FILE</VButton>
                        <!-- <VButton @click="confirmEraseWrite" variant="dark" group="middle">ERASE & WRITE</VButton>
                        <VButton @click="confirmWritePartial" variant="dark" group="middle" v-if="modelValue">WRITE PARTIAL</VButton>
                        <VButton @click="confirmWriteOnly" variant="dark" group="right">WRITE-ONLY</VButton>
                        <VButton variant="dark" group="right">VERIFY (TBD)</VButton> -->
                    </div>
                </div>
            </p>
        </div>
        
        <div class="flex-1 lg:ml-5">
            <Modal ref="flashModal" :title="title">
                <template #body>
                    <div class="w-full bg-darker rounded-full my-8 overflow-hidden">
                        <div
                        class="bg-green h-2.5 rounded-full"
                        :style="{ width: progress + '%' }"
                        role="progressbar"
                        aria-valuenow="0"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        >&nbsp;</div>
                    </div>
                    <p class="mt-4">Elapsed Time: {{ elapsedTime }} seconds</p>
                    <p>Estimated Remaining Time: {{ remainingTime }} seconds</p>
                </template>
                <template #footer>
                    <VButton @click="cancelOperation" variant="red" class="mr-4">CANCEL</VButton>
                    <VButton v-if="showDownloadButton" @click="cancelAndDownloadPartialDump" variant="red">CANCEL & DOWNLOAD PARTIAL</VButton>
                </template>
            </Modal>

            <DumpInfo :flash="flash" :flashContents="modelValue" ref="dumpInfoModal" />
            <!-- Include Confirmation Modal Component -->
            <ConfirmationModal ref="confirmationModal" />
        </div>
    </div>
</template>

<script>
import { Flashdumper } from "../flash/flashdumper";
import SFDP from "./SFDP.vue";
import { buildFileSelector, downloadUint8ArrayAsBin, formatMemorySize } from "../flash/util";
import * as bootstrap from "bootstrap";
import DumpInfo from "./DumpInfo.vue";
import ConfirmationModal from "./ConfirmationModal.vue"; // Import the new component
import {getFileAsUint8Array } from "../Util"
import VButton from "./VButton.vue";
import { DataSource, FlashContents } from "../flash/FlashContents";
import Modal from "./Modal.vue";

//import "../bootstrap-overides.scss"
export default {
    components: {
        SFDP,
        DumpInfo,
        ConfirmationModal,
        Modal,
        VButton
    },
    data() {
        return {
            sfdp: null,
            progress: 0,
            elapsedTime: 0,
            remainingTime: 0,
            title: "",
            showDownloadButton: false,
            cancel: false,
            downloadPartial: false,
        };
    },
    props: {
        flash: {
            type: Object,
            required: true,
        },
        modelValue: {
            type: Object,
            required: true
        }
    },
    methods: {
        showModal() {
            this.$refs.flashModal.show();
            // this.modal = new bootstrap.Modal(document.getElementById("flashModal"), {
            //     backdrop: "static",
            //     keyboard: false,
            // });
            // this.modal.show();
        },
        prepareProgressModal(title) {
            this.cancel = false;
            this.title = title;
            this.progress = 0;
            this.elapsedTime = 0;
            this.remainingTime = 0;
            this.showModal();
            this.startTime = Date.now();
            this.updateElapsedTime = setInterval(() => {
                this.elapsedTime = Math.floor((Date.now() - this.startTime) / 1000);
                if (this.progress >= 100) clearInterval(this.updateElapsedTime);
            }, 100);
        },
        updateProgressModal(progress) {
            this.progress = 100 * progress;
            const timeElapsed = (Date.now() - this.startTime) / 1000;
            if (progress > 0) {
                const estimatedTotalTime = timeElapsed / progress;
                this.remainingTime = Math.floor(estimatedTotalTime - timeElapsed);
            }
        },
        hideModal() {
            clearInterval(this.updateElapsedTime);
            this.$refs.flashModal.hide();
            console.log("hideModal", this.$refs.flashModal);
        },
        cancelAndDownloadPartialDump() {
            this.downloadPartial = true;
            this.cancelOperation();
        },
        cancelOperation() {
            if(this.cancel) {
                this.hideModal();
                return;
            }
            this.cancel = true;
        },

        async read() {
            await this.readFunction(false);
        },

        async readFunction(skip_modal = false) {
            console.log("REading", skip_modal)
            // Check if busy
            if(this.flash.adapter.supports_idle_check) {
                const pinState = await this.flash.adapter.pinState()

                if(pinState === 1) {
                    alert("SPI bus is not idle.")
                    return;
                }
            }

            this.prepareProgressModal("Reading flash");
            this.showDownloadButton = true;
            this.downloadPartial = false;
            this.$emit("update:modelValue", null);

            try {
                let res = await this.flash.read(256, this.flash.getCapacity(), 0, (progress) => {
                    this.updateProgressModal(progress);
                    if (this.cancel) {
                        return true;
                    }
                    return false;
                })

                // Create FlashContents object
                let fc = await FlashContents.createFromData(res, this.downloadPartial, DataSource.Dump);
                if(!skip_modal) {
                    console.log("NOT SKIP MODAL");
                    this.hideModal();
                } else {
                    console.log("SKIP MODAL");
                }
                if (this.cancel && !this.downloadPartial) {
                    return;
                }
                
                if (this.downloadPartial) {
                    // TODO: This is just to make testing with demoadapter faster
                    this.$emit("update:modelValue", fc);
                    if(!skip_modal) {
                        downloadUint8ArrayAsBin("flash_partial.bin", res);
                    }
                } else {
                    this.$emit("update:modelValue", fc);
                    if(!skip_modal) {
                        downloadUint8ArrayAsBin("flash.bin", res);
                    }
                }
                if(!skip_modal) {
                    this.$refs.dumpInfoModal.show();
                }
            } catch (exception) {
                console.log("Yo")
                alert("Error: " + exception)
                if(!skip_modal) {
                    console.log("NOT SKIP MODAL");
                    this.hideModal();
                    this.hideModal()
                }
            }
        },
        
        _confirmHandling(localStorageKey, targetFunction, title, description) {
            if (localStorage.getItem(localStorageKey) === "true") {
                targetFunction();
            } else {
                this.$refs.confirmationModal.show(
                    title,
                    description,
                    targetFunction,
                    localStorageKey
                );
            }
        },
        confirmErase() {
            this._confirmHandling(
                "skipEraseConfirmation",
                this.erase,
                "Erase flash",
                "Are you sure you want to erase the flash?"
            );
        },

        // confirmEraseWrite() {
        //     this._confirmHandling(
        //         "skipEraseWriteConfirmation",
        //         this.erase_write,
        //         "Erase and write flash",
        //         "Are you sure you want to erase and then write the flash?"
        //     );
        // },
        confirmWrite() {
            var warning = "";
            if(this.modelValue) {
                warning = "<br/><br/><strong>The write will only write changes to the currently loaded contents. Issue a read if you are unsure whether the currently loaded contents are correct.</storng>"
            }
            this._confirmHandling(
                "skipWriteConfirmation",
                this.write,
                "Write to flash",
                "Are you sure you want to perform a write to the flash?" + warning
            );
        },
        // confirmWritePartial() {
        //     this._confirmHandling(
        //         "skipWritePartialConfirmation",
        //         this.writePartial,
        //         "Partial write to flash",
        //         "Are you sure you want to perform a partial write to the flash?\n\nNote that this only works if your currently loaded image is identical to the flash contents. If you are not sure perform a read first."
        //     );
        // },
        // confirmWriteOnly() {
        //     this._confirmHandling(
        //         "skipWriteOnlyConfirmation",
        //         this.writeOnly,
        //         "Write to flash",
        //         "Are you sure you want to write to the flash?\n\nNote that flashes need to be erased first, so if your chip is not blank please select 'Erase & Write'.",
        //     );
        // },
        // confirmWrite() {
        //     this._confirmHandling(
        //         "skipWriteConfirmation",
        //         this.write,
        //         "Write to flash",
        //         "Are you sure you want to write to the flash?\n\nNote that flashes need to be erased first, so if your chip is not blank please select 'Erase & Write'.",
        //     );
        // },

        showError(error_message) {
            alert("Error: " + error_message);
            console.log("Showing error: " + error_message)
            this.hideModal()
        },

        findDifferences(currentContents, newContents, alignment = 4096) {
            if (currentContents.length !== newContents.length) {
                throw new Error("Different lengths");
            }

            const length = currentContents.length;
            const seenOffsets = new Set();
            const differences = [];

            for (let i = 0; i < length; i++) {
                if (currentContents[i] !== newContents[i]) {
                    // Round down 'i' to the nearest multiple of 'alignment'
                    const alignedOffset = Math.floor(i / alignment) * alignment;

                    // Only add one entry per aligned block
                    if (!seenOffsets.has(alignedOffset)) {
                        seenOffsets.add(alignedOffset);

                        // Slice 'alignment' bytes from newContents starting at 'alignedOffset'
                        const diffBlock = newContents.slice(
                            alignedOffset,
                            alignedOffset + alignment
                        );
                        console.log("Offset", alignedOffset);

                        differences.push([alignedOffset, diffBlock]);
                    }
                }
            }

            return differences;
        },

        async ewPartial() {
            if(!this.modelValue) {
                // throw("No read data to perform partial with.")
                this.modelValue = await getFileAsUint8Array();
            }
            let newData = await getFileAsUint8Array();

            let differences = this.findDifferences(this.modelValue, newData)

            console.log(differences)
            for(var i = 0; i < differences.length; i++) {
                let difference = differences[i];
                console.log("Erasing " + difference[0])
                try {
                    await this.flash.erase(difference[0], 4096, (progress) => {
                        console.log("ew partial progress");
                    })
                    await this.flash.write(difference[0], difference[1], (progress) => {
                        console.log("write partial progress")
                    });
                
                    let data = await this.flash.read(256, 4096, difference[0], (progress) => {
                        console.log("read partial")
                    })
                    if(data == difference[1]) {
                        console.log("EQUAL")
                        console.log(data)
                        console.log(difference[1])
                    } else {
                        console.log("UNEQUAL")
                        console.log(data)
                        console.log(difference[1])
                    }
                } catch(exception) {
                    this.showError(exception)
                }
            }
        },

        async write() {
            let newData = await getFileAsUint8Array();
            if(!newData) {
                return;
            }

            if(newData.length < this.flash.getCapacity()) {
                alert("The file is too small.")
                return;
            }

            if(!this.modelValue) {
                // perform read first
                console.log("SHOULD PERFORM READ")
                // perform read with skipping modal
                await this.readFunction(true);
            }

            if(this.modelValue && (this.modelValue.data.length !== newData.length)) {
                alert(`Data length of selected file is not identical to read data. Currently unsupported. Loaded ${this.modelValue.length} vs file ${newData.length}`);
                return;
            }

            let differences = this.findDifferences(this.modelValue.data, newData)
            console.log(`Found ${differences.length} differences`)

            this.showDownloadButton = false;

            this.prepareProgressModal("Writing flash");

            for(var i = 0; i < differences.length; i++) {
                let difference = differences[i];
                await this.flash.erase(difference[0], 4096, (progress) => {
                    // console.log("ew partial progress");
                })
                await this.flash.write(difference[0], difference[1], (progress) => {
                    // console.log("write partial progress")
                });
                let data = await this.flash.read(256, 4096, difference[0], (progress) => {
                    // console.log("read partial")

                    this.updateProgressModal(i/differences.length);
                    if (this.cancel) {
                        return true;
                    }
                    return false;
                })
                if (this.cancel) {
                    break;
                }
                // Javascript is a meme...
                if(indexedDB.cmp(data, difference[1]) !== 0) {
                    throw new Error(`Failed to verify contents at address: 0x${difference[0].toString(16)}`);
                }
            }
            // this.updateProgressModal(0);
            this.hideModal();
        },

        // async writePartial() {
        //     let newData = await getFileAsUint8Array();
        //     if(newData.length !== this.modelValue.length) {
        //         alert(`Data length of selected file is not identical to loaded file. Loaded ${this.modelValue.length} vs file ${newData.length}`);
        //         return;
        //     }
        //     let differences = this.findDifferences(this.modelValue, newData)
        //     for(var i = 0; i < differences.length; i++) {
        //         let difference = differences[i];
        //         console.log("Erasing " + difference[0])
        //         await this.flash.erase(difference[0], 4096, (progress) => {
        //             console.log("ew partial progress");
        //         })
        //         await this.flash.write(difference[0], difference[1], (progress) => {
        //             console.log("write partial progress")
        //         });
        //         let data = await this.flash.read(256, 4096, difference[0], (progress) => {
        //             console.log("read partial")
        //         })
        //         if(data == difference[1]) {
        //             console.log("EQUAL")
        //             console.log(data)
        //             console.log(difference[1])
        //         } else {
        //             console.log("UNEQUAL")
        //             console.log(data)
        //             console.log(difference[1])
        //         }
        //     }
        // },

        // async writeOnly() {
        //     let fs = await getFileAsUint8Array();
        //     if(!fs) {
        //         alert("No file selected.");
        //         return;
        //     }
        //     if(fs.length < this.flash.getCapacity()) {
        //         alert("Your file is too small. Proceed with partial write?")
        //     }

        //     this.showDownloadButton = false;
        //     this.prepareProgressModal("Writing flash");

        //     try {
        //         await this.flash.write(0, fs, (progress) => {
        //             this.updateProgressModal(progress);
        //             if (this.cancel) {
        //                 return true;
        //             }
        //             return false;
        //         });
        //         this.hideModal();
        //     } catch (error) {
        //         alert("Error while writing to flash: " + error);
        //         this.cancel = true;
        //         this.updateProgressModal(0);
        //         this.hideModal();
        //         return;
        //     }
        // },
        erase() {
            console.log("Erase")
            this.showDownloadButton = false;
            this.prepareProgressModal("Erasing flash");

            this.flash.erase(0, this.flash.getCapacity(), (progress) => {
                this.updateProgressModal(progress);
                if (this.cancel) {
                    return true;
                }
                return false;
            }).then(() => {
                this.hideModal();
            });
        },

        // async erase_write() {
        //     console.log("erase_write")
        //     let fs = await getFileAsUint8Array();

        //     if(!fs) {
        //         alert("No file selected.");
        //         return;
        //     }
        //     console.log("SFDP", this.flash.sfdp)
        //     if(fs.length < this.flash.getCapacity()) {
        //         // alert("Your file is too small. Proceed with partial write?")
        //     }

        //     this.showDownloadButton = false;

        //     await this.erase();

            
        //     this.prepareProgressModal("Writing flash");

        //     try {
        //         await this.flash.write(0, fs, (progress) => {
        //             this.updateProgressModal(progress);
        //             if (this.cancel) {
        //                 return true;
        //             }
        //             return false;
        //         });
        //         this.hideModal();
        //     } catch (error) {
        //         alert("Error writing to flash: " + error);
        //         this.cancel = true;
        //         this.updateProgressModal(0);
        //         this.hideModal();
        //         return;
        //     }
        // },
        async erase() {
            this.showDownloadButton = false;
            this.prepareProgressModal("Erasing flash");

            await this.flash.erase(0, this.flash.getCapacity(), (progress) => {
                this.updateProgressModal(progress);
                if (this.cancel) {
                    return true;
                }
                return false;
            })
            this.hideModal();
        },
    },
};
</script>

<style scoped>
.rounded-l-md {
    border-top-left-radius: .375rem;
    border-bottom-left-radius: .375rem;
}

.rounded-r-md {
    border-top-right-radius: .375rem;
    border-bottom-right-radius: .375rem;
}
</style>
